import "./Privacy.css";
import Header from "./Header";
import Footer from "./Footer";
import { useState } from "react";
import { BsTypeH1 } from "react-icons/bs";
import SEO from "./SeoHelmet";
import metaConfig from "./SeoComponent";
import { useLocation } from "react-router-dom";

function Privacy() {
  const location = useLocation(); // Get the current location (path)

  const meta = metaConfig.privacypolicy;

  const [submenuOpen, setSubmenuOpen] = useState(false);

  return (
    <div>
      <SEO {...meta} />

      <div class="container-fluid position-relative p-0">
        <div class="w-100 me-3 top_head">
          <div class="top_head align-items-center"></div>
        </div>
        <Header />
      </div>
      {/* <!-- Navbar & Hero End -->
    <!-- Header Start --> */}
      <div class="container-fluid Privacy bg-breadcrumb">
        <div class="container text-center py-5" style={{ maxWidth: "9000px" }}>
          <ol
            class="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown"
            data-wow-delay="0.3s"
          ></ol>
          <h4
            class="text-white display-6 mb-4 wow fadeInDown"
            data-wow-delay="0.1s"
          >
            Safeguarding Your Information
          </h4>
        </div>
      </div>
      {/* <!-- Header End --> */}

      {/* <!-- Modal Search Start --> */}
      <div
        class="modal fade"
        id="searchModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-fullscreen">
          <div class="modal-content rounded-0">
            <div class="col-lg-12 m-auto modal-header justify-content-lg-end">
              <button
                type="button"
                class="btn-close justify-content-lg-end text-white"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="col-lg-9 m-auto modal-header align-items-center text-center">
              <h4
                class="modal-title mb-0 m-auto text-white"
                id="exampleModalLabel"
              >
                Search by keyword
              </h4>
            </div>
            <div class="modal-body align-items-center">
              <div class="input-group w-75 mx-auto d-flex">
                <input
                  type="search"
                  class="form-control p-3"
                  placeholder="keywords"
                  aria-describedby="search-icon-1"
                />
                <span
                  id="search-icon-1"
                  class="input-group-text btn border p-3"
                >
                  <i class="fa fa-search text-white"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Modal Search End --> */}

      <div class="container-fluid innercontain  privacyinner about overflow-hidden py-5">
        <div class="container">
          <div class="row g-5">
            <div
              class="col-xl-9 mt-5 m-auto wow fadeInRight"
              data-wow-delay="0.2s"
            >
              <div class="about-item text-center">
                <h1
                  class="text-white display-3 mb-4 wow fadeInDown"
                  data-wow-delay="0.1s"
                >
                  KTIG Privacy Policy
                </h1>
                <p class="text-white text-center">
                  At KTIG, we prioritize your privacy and are dedicated to
                  safeguarding your information.
                </p>
              </div>

              <div class="row mt-5 goals_rules privacy g-4 justify-content-center">
                <div
                  class="col-lg-10 col-xl-10 wow fadeInUp"
                  data-wow-delay="0.2s"
                >
                  <h3 class="mb-4 text-white text-animation">
                    Data Protection
                  </h3>
                  <ul>
                    <ol class="text-white text-animation">
                      <i class="fas fa-angle-right me-2"></i>
                      <span>
                        We collect and handle data in compliance with Indian
                        data protection laws.
                      </span>
                    </ol>
                    <ol class="text-white text-animation">
                      <i class="fas fa-angle-right me-2"></i>
                      <span>
                        We implement industry-standard security protocols to
                        ensure the safety of your information.
                      </span>
                    </ol>
                    <ol class="text-white text-animation">
                      <i class="fas fa-angle-right me-2"></i>
                      <span>
                        Strict confidentiality measures are followed for all
                        client data.
                      </span>
                    </ol>
                    <ol class="text-white text-animation">
                      <i class="fas fa-angle-right me-2"></i>
                      <span>
                        Regular security audits and updates are conducted to
                        preserve data integrity.
                      </span>
                    </ol>
                  </ul>
                </div>
              </div>

              <div class="row mt-0 goals_rules privacy justify-content-center">
                <div
                  class="col-lg-10 col-xl-10 wow fadeInUp"
                  data-wow-delay="0.2s"
                >
                  <h3 class="mb-4 text-white text-animation">
                    Information Usage
                  </h3>
                  <ul>
                    <ol class="text-white text-animation">
                      <i class="fas fa-angle-right me-2"></i>
                      <span>
                        The data we collect is used exclusively for business
                        purposes and service delivery.
                      </span>
                    </ol>
                    <ol class="text-white text-animation">
                      <i class="fas fa-angle-right me-2"></i>
                      <span>
                        Client information is never shared with unauthorized
                        third parties.
                      </span>
                    </ol>
                    <ol class="text-white text-animation">
                      <i class="fas fa-angle-right me-2"></i>
                      <span>
                        We maintain transparency regarding how your data is used
                        and stored.
                      </span>
                    </ol>
                    <ol class="text-white text-animation">
                      <i class="fas fa-angle-right me-2"></i>
                      <span>
                        Clients have the right to access and manage their
                        information.
                      </span>
                    </ol>
                  </ul>
                </div>
              </div>

              <div class="row mt-0 goals_rules privacy justify-content-center">
                <div
                  class="col-lg-10 col-xl-10 wow fadeInUp"
                  data-wow-delay="0.2s"
                >
                  <h3 class="mb-4 text-white text-animation">
                    Security Measures
                  </h3>
                  <ul>
                    <ol class="text-white text-animation">
                      <i class="fas fa-angle-right me-2"></i>
                      <span>
                        We use advanced encryption methods to protect all
                        digital communications.
                      </span>
                    </ol>
                    <ol class="text-white text-animation">
                      <i class="fas fa-angle-right me-2"></i>
                      <span>
                        Our storage systems are highly secure, featuring
                        multiple layers of protection.
                      </span>
                    </ol>
                    <ol class="text-white text-animation">
                      <i class="fas fa-angle-right me-2"></i>
                      <span>
                        Staff undergoes regular training on data protection best
                        practices.
                      </span>
                    </ol>
                    <ol class="text-white text-animation">
                      <i class="fas fa-angle-right me-2"></i>
                      <span>
                        We have swift response protocols in place for addressing
                        any security concerns.
                      </span>
                    </ol>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />

      <a
        href="#"
        class="btn btn-secondary btn-lg-square rounded-circle back-to-top"
      >
        <i class="fa fa-arrow-up"></i>
      </a>
    </div>
  );
}

export default Privacy;
